export default __webpack_public_path__ + "static/media/title_sp.4e2cc82d.png";